import { createPageApp } from '@/lib/createPageApp'
import TeacherCabinetPage from './TeacherCabinetPage.vue'

createPageApp(TeacherCabinetPage).mount()
